export default "/assets/images/filter-MB.png?a83fdaf7ad06a817e7796cac42a214a8";